<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container [formGroup]="accountInformations">
      <div class="row">
        <div class="col-md-12">
          <pr-input-radio
            [derrors]="derrors"
            formControlName="durationBeginInvestment"
            direction="column"
            [isDefault]="false"
            columns="4"
            [options]="durationBeginInvestmentOption"
            label="Depuis combien de temps réalisez-vous des investissements ?"
          >
          </pr-input-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="enableContactActuScpi"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Souhaitez-vous être informé des actualités des SCPI ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-6">
          <pr-input-radio
            formControlName="enableDematerializationDocuments"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Souhaitez-vous que les documents (bulletins trimestriels, convocations aux assemblées générales...) soient dématérialisés ?"
          >
          </pr-input-radio>
        </div>
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
